export const mockMeta = {
  farmCode: "X10AI_FT_060",
  farmName: "Sample Beef & Sheep Farm",
  region: "Shropshire / Mid-Wales",
  system: "Lowland beef and sheep",
  dateLabel: "13 November 2025",
};

export const mockPriorities = [
  "Ground is soft but trafficable; avoid heavy slurry tankers on river meadows today.",
  "Beef and lamb prices are firm and trending upwards; plan to draft finished cattle and heavier lambs for sale within 7–10 days.",
  "Fluke risk is high on wet, low-lying fields; avoid grazing susceptible stock and check treatment status.",
  "SFI action review is due in 7 days; allocate time this week to update records.",
];

export const mockWeather = {
  location: "Near Welshpool, mid-Wales",
  today: {
    maxTemp: "9°C",
    minTemp: "3°C",
    rainMm: 4,
    wind: "14 mph (W)",
    frostRisk: "Moderate",
  },
  fieldConditions: [
    { label: "Overall", status: "Soft, trafficable", risk: "ok" },
    { label: "Block 1 (home fields)", status: "Soft – suitable for light tractors", risk: "ok" },
    { label: "Block 3 (river meadows)", status: "High poaching risk – avoid heavy stock", risk: "risk" },
  ],
};

export const mockGrass = {
  region: "Shropshire lowland",
  currentGrowth: "26 kg DM/ha/day",
  avg7d: "24 kg DM/ha/day (↑ 2)",
  dmEstimate: "17 %",
  grazingDaysAhead: 10,
  note: "Grass growth is slightly above the 7-day average. At current stocking, you have an estimated 10 days of grazing before covers drop below target.",
};

export const mockHealth = {
  region: "West Midlands & Mid-Wales",
  parasiteRisk: "Medium – nematodirus low, fluke high on wet ground.",
  flukeRiskLevel: "High on fields within 200 m of watercourses.",
  heatStress: "Low – THI 52",
  chillRisk: "Medium – wind 14 mph and overnight lows around 3°C.",
};

export const mockSlurry = {
  nvzStatus: "Within NVZ – spreading allowed today.",
  suitability: "Fair – soil moisture high, 4 mm rain forecast.",
  runoffRisk: "High – avoid spreading on Block 3 (river meadows).",
  storeFillPercent: 78,
  daysUntilFull: 19,
};

export const mockMarket = {
  beef: {
    classLabel: "R4L steers (deadweight, England/Wales)",
    lastPrices: [
      { date: "06 Nov", price: 461 },
      { date: "07 Nov", price: 462 },
      { date: "08 Nov", price: 463 },
      { date: "09 Nov", price: 465 },
      { date: "10 Nov", price: 466 },
      { date: "11 Nov", price: 467 },
      { date: "12 Nov", price: 469 },
    ],
    ma7: 465,
    forecast: { min: 471, max: 475 },
    trend: "up",
    comment:
      "Seven-day trend is rising (+8 p/kg). Short-term forecast suggests firm or improving beef prices; consider drafting finished cattle for sale in the next 7–10 days.",
  },
  lamb: {
    classLabel: "Standard SQQ lambs (liveweight)",
    lastPrice: 264,
    ma7: 259,
    forecast: { min: 261, max: 266 },
    trend: "up",
    comment:
      "Lamb prices are slightly above the 7-day average with a modest upward trend.",
  },
};

export const mockPolicy = [
  "Defra consultation on slurry storage rules – responses due 30 November 2025.",
  "Welsh Government update on Sustainable Farming Scheme pilot – expressions of interest close 20 November 2025.",
  "Upper Severn high priority catchment advisory – reduce winter spreading close to watercourses.",
];

export const mockTwinSignals = {
  nutrientBalance: {
    nSurplus: "+4.5 kg N/ha (target +3)",
    pSurplus: "+0.2 kg P/ha (within target)",
    note: "Nitrogen surplus is slightly above target; consider adjusting next week’s fertiliser plan on Blocks 1 and 2.",
  },
  carbonIntensity: {
    lastWeek: "18.2 kg CO₂e/kg LWG",
    previousWeek: "19.0 kg CO₂e/kg LWG",
    trend: "Improving (–4.2 %)",
  },
  pasturePerformance: {
    utilisation: "78 % (target 80–85 %)",
    lwgDeviation: "–4 % below modelled expectation for 300 kg stores on Field 5.",
  },
};

export const mockDeadlines = [
  {
    date: "19 Nov 2025",
    text: "SFI quarterly action review due (England).",
  },
  {
    date: "21 Nov 2025",
    text: "Red Tractor audit window opens.",
  },
  {
    date: "30 Nov 2025",
    text: "Medicine book check: confirm antibiotic records are up to date.",
  },
];